import {KpiProps} from "../../../../../types/types";
import {Button, MantineTheme, Popover, Table} from "@mantine/core";
import {faCircleInfo,faNotesMedical} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";
import { QueryViewModal } from "./modal/queryViewModal";
import { ScriptViewModal } from "./modal/scriptViewModal";

export function ReviewStep(props: KpiProps) {

    const kpiInfo = props.kpiInfo;
    const [openedDescription, setOpenedDescription] = useState(false);
    const [openedScript, setOpenedScript] = useState(false);
    const [openedQueries, setOpenedQueries] = useState(false);
    let selectedAggregartions = "";
    kpiInfo.aggregationNames && kpiInfo.aggregationNames.forEach((aggregationName,index) =>{
        if(index===0){
            selectedAggregartions+=aggregationName;
            return;
        }
        selectedAggregartions+=", "+aggregationName;
    })


    const themeProvider = (theme: MantineTheme) => ({
        // backgroundColor: theme.colors.gray[0],
        '&:hover': {
            // backgroundColor: theme.colors.gray[1],
        },
    })

    return (
        <div className="kpi-filter-wrapper full-width-height wizard-content-card">
            <div>
                <Table sx={themeProvider}>
                    <thead>
                    <tr>
                        <th style={{textAlign: "center", width: "10rem"}}>KPI Name</th>
                        <th style={{textAlign: "center", width: "10rem"}}>Owner</th>
                        <th style={{textAlign: "center", width: "10rem"}}>Description</th>
                        {props.kpiInfo.extendedAttributes && props.kpiInfo.extendedAttributes.documentation &&
                            <th style={{textAlign: "center", width: "10rem"}}>Documentation</th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{textAlign: "center"}}>
                        <td>{kpiInfo.name}</td>
                        <td>{kpiInfo.owner}</td>
                        <td>
                            <Popover
                                opened={openedDescription}
                                onClose={() => setOpenedDescription(false)}
                                onMouseEnter={() => setOpenedDescription(true)}
                                onMouseLeave={() => setOpenedDescription(false)}
                                position="bottom"
                                placement="center"
                                withArrow
                                trapFocus={false}
                                closeOnEscape={false}
                                transition="pop-top-left"
                                width={260}
                                styles={{body: {pointerEvents: 'none'}}}
                                target={
                                    <FontAwesomeIcon icon={faCircleInfo} color="#8ab4f7"/>
                                }
                            >
                                <div style={{display: 'flex'}}>
                                {props.kpiInfo.description}
                                </div>
                            </Popover>
                        </td>
                        {props.kpiInfo.extendedAttributes && props.kpiInfo.extendedAttributes.documentation &&
                            <td>
                                <a href={props.kpiInfo.extendedAttributes.documentation}  rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faNotesMedical} color="#8ab4f7"/></a>
                            </td>
                        }
                    </tr>
                    </tbody>
                </Table>
            </div>
            <div>
                <Table sx={themeProvider}>
                    <thead>
                    <tr>
                        <th style={{width: "40%", textAlign: "center"}}></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{textAlign: "center"}}>
                        <td>Target Type</td>
                        <td>{kpiInfo.target}</td>
                    </tr>
                    {kpiInfo.extendedAttributes && kpiInfo.extendedAttributes.refreshMode && <tr style={{textAlign: "center"}}>
                        <td>Refresh Mode</td>
                        <td>{kpiInfo.extendedAttributes.refreshMode}</td>
                    </tr>}

                    {kpiInfo.targetFilter && <tr style={{textAlign: "center"}}>
                        <td>Filter</td>
                        <td>{kpiInfo.targetFilter}</td>
                    </tr>}

                    {kpiInfo.cron && <tr style={{textAlign: "center"}}>
                        <td>Scheduling Time</td>
                        <td>{kpiInfo.cron}</td>
                    </tr>}

                    {kpiInfo.aggregationNames && kpiInfo.aggregationNames.length>0 &&
                        <tr style={{textAlign: "center"}}>
                            <td>Aggregations</td>
                            <td>{selectedAggregartions}</td>
                        </tr>
                    }
                    {/* <tr style={{textAlign: "center", marginTop: "1rem"}}>
                        <td>
                            <Button variant={"outline"} color="teal" onClick={() => setOpenedQueries(true)}>View Queries</Button>
                        </td>
                        <td>
                            <Button variant={"outline"} color="teal" onClick={() =>setOpenedScript(true)}>View Script</Button>
                        </td>
                    </tr> */}
                    </tbody>
                </Table>
            </div>
            <div style={{display: "grid", gridTemplateColumns: "43% 43%", gap:"6%", marginTop:"1rem"}}>
                {props.kpiInfo.configuration && props.kpiInfo.configuration && props.kpiInfo.configuration.queries && props.kpiInfo.configuration.queries.length > 0 && 
                    <div style={{textAlign: "center"}}>
                        <Button variant={"outline"} color="teal" onClick={() => setOpenedQueries(true)}>View Queries</Button>
                    </div>
                }
                { props.kpiInfo.statusEvaluator &&
                    <div style={{textAlign: "center"}}>
                        <Button variant={"outline"} color="teal" onClick={() =>setOpenedScript(true)}>View Script</Button>
                    </div>
                }
                <ScriptViewModal setOpenedScript={setOpenedScript} openedScript={openedScript} script={props.kpiInfo.statusEvaluator} />
                <QueryViewModal setOpenedQueries={setOpenedQueries} openedQueries={openedQueries} queryList={props.kpiInfo.configuration.queries}/>
            </div>
        </div>

    );
}